<template>
    <div class="d-flex justify-content-between align-items-center py-4 pr-4 pl-2" id="footer-section" :style="{'margin-top': footer_top_margin+'px'}">
        <div class="d-flex align-items-center mb-small-10" style="gap:1rem">
            <div class="fs-12 fw-600 text-black">© Copyright 2014 - {{ new Date().getFullYear() }} DigiCollect - All Rights Reserved.</div>
            <!-- <div class="helpdesk-footer pointer" @click="openHelpdesk()">
                <img src="/static/images/new-theme2024/helpdesk-footer.png" class="help-desk-image w-140px" alt="helpdesk-logo"/>
            </div> -->
        </div>
        <div style="display: flex;align-items: center;gap: 1rem;">
            <span class="text-black fw-600">V3.2.0</span>
            <img class="show_comp_logo mr-4" width="20" src="/static/images/new-theme2024/digi-footer-logo.png" alt="digi-footer-logo">
            <img src="/static/images/new-theme2024/home-icon-footer.png" alt="home-icon" class="footer-icon-size"/>
            <img src="/static/images/new-theme2024/search-icon-footer.png" alt="search-icon" class="footer-icon-size" />
            <img src="/static/images/new-theme2024/message-icon-footer.png" alt="message-icon" class="footer-icon-size" />
        </div>
    </div>
</template>

<script>

export default{
    data() {
        return{
            footer_top_margin: 0,
        }
    },
    methods: {
        openHelpdesk(){
            if(location.origin.startsWith('http://localhost') || location.origin == 'http://testexpense.digicollect.com/'){
                window.open('https://testhelpdesk.digicollect.com/','_blank');
            }else if(location.origin == 'https://expense.digicollect.com/'){
                window.open('https://helpdesk.digicollect.com/','_blank');
            }
        },
        FooterSpacing(){
            let router_relative = document.getElementById('router-relative').clientHeight
            let main_navbar = document.getElementById('main-navbar').clientHeight
            let main_section = document.getElementById('main').clientHeight
            let footer_section = document.getElementById('footer-section').clientHeight
            if((main_section - (router_relative + main_navbar + footer_section)) - 2 >= 0){
                this.footer_top_margin = (main_section - (router_relative + main_navbar + footer_section)) - 2
            } else {
                this.footer_top_margin = 0
            }
        }
    },
    mounted(){
        // window.onresize = this.FooterSpacing
	},
    // watch: {
    //     '$route': function() {
    //         console.log('object footer');
    //         let router_relative = document.getElementById('router-relative').clientHeight
    //         let main_navbar = document.getElementById('main-navbar').clientHeight
    //         let main_section = document.getElementById('main').clientHeight
    //         let footer_section = document.getElementById('footer-section').clientHeight
    //         if((main_section - (router_relative + main_navbar + footer_section)) - 2 >= 0){
    //             this.footer_top_margin = (main_section - (router_relative + main_navbar + footer_section)) - 2
    //         } else {
    //             this.footer_top_margin = 0
    //         }
    //     }
    // }
}
</script>

<style scoped>

</style>